export default "__VITE_ASSET__27378db9__"